<template>
  <div>
    <ul
      class="pagination pagination-sm pull-left"
      style="margin-top: 6px; font-style: italic; color: #337ab7"
      v-if="paginationDataList.length"
    >
      <p>
        {{ $t("paginator.showing") }} {{ start }} - {{ end }}
        {{ $t("paginator.of") }} {{ total }} {{ $t("paginator.records") }}
      </p>
    </ul>
    <ul
      class="pagination pagination-sm no-margin pull-right"
      v-if="paginationDataList.length"
    >
      <li
        v-bind:class="{ disabled: pageSelected <= 1 }"
        @click="onPrevPagination"
      >
        <a>&laquo;</a>
      </li>
      <li
        v-for="(page, index) in paginationDataList"
        :key="index"
        :value="page.value"
        @click="onPagination(page.value)"
        :class="{ active: page.target }"
      >
        <a>{{ page.text }}</a>
      </li>
      <li
        v-bind:class="{ disabled: pageSelected >= totalPage }"
        @click="onNextPagination"
      >
        <a>&raquo;</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Paginator",

  props: {
    // item: {
    //   type: Object,
    //   default: () => {}
    // },
    totalItem: {
      type: Number,
      default: () => {
        return 1;
      }
    },
    currentPage: {
      type: Number,
      default: () => {
        return 1;
      }
    },
    pageSize: {
      type: Number,
      default: () => {
        return 1;
      }
    },
    totalPage: {
      type: Number,
      default: () => {
        return 1;
      }
    }
  },

  data() {
    return {
      commit_function: null,
      paginationDraw: 2,
      pageSelected: 1
    };
  },

  watch: {
    // item: function() {
    //   this.create();
    // }
    currentPage: function() {
      this.pageSelected = this.currentPage;
    }
  },

  computed: {
    ...mapGetters([]),
    start() {
      return 1 + (this.currentPage - 1) * this.pageSize;
    },
    end() {
      const maxPage = Math.floor((this.totalItem - 1) / this.pageSize) + 1;
      if (this.currentPage < maxPage) {
        return this.pageSize + (this.currentPage - 1) * this.pageSize;
      }
      return this.totalItem;
    },
    total() {
      return this.totalItem;
    },
    paginationDataList() {
      let paginatorResult = [];
      let targetPage = this.pageSelected;
      let isBeforeJump = false;
      let isAfterJump = false;

      const minPage = 1;
      const maxPage = Math.floor((this.totalItem - 1) / this.pageSize) + 1;

      if (targetPage > maxPage) {
        targetPage = maxPage;
      }
      if (targetPage < 1) {
        targetPage = 1;
      }
      let drawMin = minPage;
      let drawMax = maxPage;
      if (
        targetPage - this.paginationDraw < minPage &&
        targetPage + this.paginationDraw > maxPage
      ) {
        drawMin = minPage;
        drawMax = maxPage;
      } else if (
        targetPage - this.paginationDraw < minPage &&
        !(targetPage + this.paginationDraw > maxPage)
      ) {
        drawMin = minPage;
        drawMax =
          drawMin + this.paginationDraw * 2 > maxPage
            ? maxPage
            : drawMin + this.paginationDraw * 2;
      } else if (
        !(targetPage - this.paginationDraw < minPage) &&
        targetPage + this.paginationDraw > maxPage
      ) {
        drawMax = maxPage;
        drawMin =
          drawMax - this.paginationDraw * 2 < minPage
            ? minPage
            : drawMax - this.paginationDraw * 2;
      } else {
        drawMin = targetPage - this.paginationDraw;
        drawMax = targetPage + this.paginationDraw;
      }

      isBeforeJump = !(drawMin === minPage);
      isAfterJump = !(drawMax === maxPage);

      paginatorResult = [];

      if (isBeforeJump) {
        paginatorResult.push({
          number: true,
          target: false,
          value: minPage,
          text: minPage
        });
        if (drawMin - 1 !== minPage) {
          paginatorResult.push({
            number: false,
            target: false,
            value: 0,
            text: "..."
          });
        }
      }

      for (let i = drawMin; i <= drawMax; i++) {
        paginatorResult.push({
          number: true,
          target: i === targetPage,
          value: i,
          text: i
        });
      }

      if (isAfterJump) {
        if (drawMax + 1 !== maxPage) {
          paginatorResult.push({
            number: false,
            target: false,
            value: 0,
            text: "..."
          });
        }
        paginatorResult.push({
          number: true,
          target: false,
          value: maxPage,
          text: maxPage
        });
      }
      return paginatorResult;
    }
  },

  methods: {
    create() {
      // this.commit_function = this.item.commit_function;
    },
    onPrevPagination: function() {
      if (this.pageSelected <= 1) {
        return;
      }
      this.pageSelected = this.pageSelected - 1;
      this.$emit("onpaginate", this.pageSelected);
    },
    onNextPagination: function() {
      if (this.pageSelected >= this.totalPage) {
        return;
      }
      this.pageSelected = this.pageSelected + 1;
      this.$emit("onpaginate", this.pageSelected);
    },
    onPagination: function(value) {
      if (value === 0) return false;
      this.pageSelected = value;
      this.$emit("onpaginate", value);
    }
  },
  mounted() {
    this.create();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/CustomPaginator.vue